import React from 'react'
import { FieldError as IFieldError } from 'react-hook-form'
import './FormFields.css'

interface FieldErrorProps {
  fieldError: IFieldError | undefined | any
}
export const FieldError: React.FC<FieldErrorProps> = ({ fieldError }) => {
  return <>{fieldError ? <div className={'fieldError'}>{fieldError.message}</div> : null} </>
}
